import type { GoalPortfolioResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { joinTruthy } from "web_myplann/Shared/Utils/textFormatters";

export const getGoalPortfolioSubtitle = (
	portfolio: Pick<GoalPortfolioResponseDTO, "producer" | "product">,
	title: string,
	domainLabel: string,
): string => {
	const subtitle = joinTruthy(
		[portfolio.producer, portfolio.product].filter((part) => part !== title),
	);

	if (subtitle) {
		return subtitle;
	}

	return title === domainLabel ? "" : domainLabel;
};
